import React from "react";
import { Paper, Snackbar } from "@mui/material";
import styled from "styled-components/macro";
import {
  ThumbsUp,
  ThumbsDown,
  AlertTriangle,
  AlertCircle,
} from "react-feather";
import { SNACK_TYPES } from "@/constants/common";
import useGlobalStore from "@/store/useGlobalStore";

const CustomSnack = styled(Snackbar)`
  background-color: white;
  border-radius: 6px;
  min-width: 240px;
  min-height: 50px;
`;

const Wrapper = styled(Paper)`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  min-height: 60px;
  min-width: 280px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 8px;
`;

const IconContainer = styled.div`
  height: 42px;
  width: 42px;
  flex-shrink: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props?.$accentColor};
`;

const getSnackMeta = (snackType) => {
  if (!snackType) return null;

  if (snackType === SNACK_TYPES.SUCCESS) {
    return {
      Icon: ThumbsUp,
      highlightColor: "seagreen",
      titleText: "Succcess",
      accentColor: "#05fb6329",
    };
  }

  if (snackType === SNACK_TYPES.ERROR) {
    return {
      Icon: ThumbsDown,
      highlightColor: "firebrick",
      titleText: "Error",
      accentColor: "#fd8d8d2e",
    };
  }

  if (snackType === SNACK_TYPES.WARNING) {
    return {
      Icon: AlertTriangle,
      highlightColor: "darkorange",
      titleText: "Warning",
      accentColor: "#fad17e2e",
    };
  }

  if (snackType === SNACK_TYPES.INFO) {
    return {
      Icon: AlertCircle,
      highlightColor: "#337ab7",
      titleText: "Info",
      accentColor: "#79c1ff38",
    };
  }
};

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  min-height: 42px;
`;

const GlobalSnack = () => {
  const snackText = useGlobalStore((state) => state.snackText);
  const snackType = useGlobalStore((state) => state.snackType);
  const clearSnackText = useGlobalStore((state) => state.clearSnackText);
  if (!snackText) return null;

  const { highlightColor, titleText, Icon, accentColor } =
    getSnackMeta(snackType);

  return (
    <CustomSnack
      autoHideDuration={6000}
      open={Boolean(snackText)}
      onClose={() => clearSnackText()}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
    >
      <Wrapper $highlighColor={highlightColor}>
        <IconContainer $accentColor={accentColor}>
          <Icon height={16} color={highlightColor} />
        </IconContainer>
        <div style={{ minWidth: 12 }} />
        <TextContainer>
          <span
            style={{ fontWeight: 600, fontSize: 14, color: highlightColor }}
          >
            {titleText}
          </span>
          <span
            style={{
              fontSize: 12,
              color: "slategrey",
              maxWidth: 300,
              lineHeight: 1.4,
            }}
          >
            {snackText}
          </span>
        </TextContainer>
      </Wrapper>
    </CustomSnack>
  );
};

export default GlobalSnack;
